import { Button, Col, Form, Input, Row, Select } from "antd";
import Iinput from "../../../auxiliary/inputs/Input";
import { validateInput, ymdTehranToISO } from "../../../../tools/tools";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";

const Address = ({ t, creditCard, setCreditCard }) => {
	const [frmAddress] = Form.useForm();

	const { queryActiveCityByProvinceId, queryActiveProvince } = useAPIPublic();
	const { registerBankCardProfile } = useDealer();

	// 👇 اسم‌ها را یک‌دست و هم‌خوان با JSX نگه می‌داریم: province, city
	const [address, setAddress] = useState({
		province: [],
		city: [],
		buttonProgress: false,
	});

	const handleCityListByProvinceId = async (provinceId) => {
		let resCity = await queryActiveCityByProvinceId(provinceId);
		if (resCity) {
			resCity = resCity.filter((item) => item.payredCityCode != null);
			setAddress((prev) => ({ ...prev, city: resCity || [] }));
			// پاک‌کردن مقدار شهر بعد از تغییر استان (اختیاری):
			frmAddress.setFieldsValue({ cityid: undefined });
		}
	};

	useEffect(() => {
		let cancelled = false;

		(async () => {
			// 1) لود استان‌ها
			const provinces = await queryActiveProvince();
			if (cancelled) return;
			setAddress((prev) => ({ ...prev, province: provinces || [] }));

			// اگر آدرس قبلاً داریم، مقادیر ثابت رو هم ست کن
			if (creditCard?.address) {
				const { provinceid, cityid, postalcode, address } = creditCard.address;

				// 2) ست‌کردن فیلدهای ثابت (بدون cityid فعلاً)
				frmAddress.setFieldsValue({
					postalcode,
					address: address,
					provinceid,
				});

				// اگر provinceid داریم، 3) شهرهای استان انتخاب‌شده را لود کن
				if (provinceid) {
					const cities = await queryActiveCityByProvinceId(provinceid);
					if (cancelled) return;
					setAddress((prev) => ({ ...prev, city: cities || [] }));

					// 4) بعد از لود شهرها cityid را ست کن
					if (cityid) {
						frmAddress.setFieldsValue({ cityid });
					}
				}
			} else {
				frmAddress.resetFields();
			}
		})();

		return () => {
			cancelled = true;
		};
		// اگر می‌خواهی فقط بار اول اجرا شود، dependency را خالی بگذار
		// اگر می‌خواهی با تغییر creditCard دوباره sync شود، creditCard را بگذار
	}, []);

	const submitHandler = async (values) => {
		try {
			const value = await frmAddress.validateFields(); // اگر خطا باشد، throw می‌کند
			setAddress((p) => ({ ...p, buttonProgress: true }));

			const payload = {
				mothername: creditCard.profile?.mothername,
				fathername: creditCard.profile?.fathername,
				firstname: creditCard.profile?.firstName,
				lastname: creditCard.profile?.lastName,
				email: creditCard.profile?.email,
				passportnumber: creditCard.profile?.passportNumber,
				occupationid: creditCard.profile.occupationid,
				// mobile: creditCard.profile?.mobile,
				// certno: creditCard.profile?.nationalId,
				birthdate: ymdTehranToISO(creditCard?.profile?.birthdate, "12:00:00", "moment"),
				address: {
					cityid: values?.cityid,
					provinceid: values?.provinceid,
					address: values?.address,
					postalcode: values?.postalcode,
					district: "",
				},
			};
			const res = await registerBankCardProfile(payload);
			if (res) {
				setCreditCard((prev) => ({ ...prev, address: { ...values }, profileId: res?.Result?.profileId, step: 2 }));
			} else {
				setAddress((p) => ({ ...p, buttonProgress: false }));
			}
		} catch (err) {
			console.log({ err });
			setAddress((p) => ({ ...p, buttonProgress: false }));
		}
	};
	return (
		<>
			<div className="g-body-format-page">
				<h3 className="header-of-form">اطلاعات آدرس پروفایل</h3>
				<div className="holder-form">
					<Form id="frmAddress" name="frmAddress" form={frmAddress} onFinish={submitHandler} layout="vertical">
						<Row gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item
									className="input-normal"
									name="postalcode"
									label="کدپستی"
									rules={[
										validateInput({
											t,
											validate: true,
											type: "number",
											length: 10,
										}),
									]}>
									<Iinput dir="ltr" maxLength={10} inputMode="numeric" placeholder="کدپستی خود را وارد کنید" />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item className="input-normal" name="provinceid" label="استان" rules={[validateInput({ t, validate: true })]}>
									<Select
										showSearch
										optionFilterProp="label" // جستجو روی label
										onChange={(value) => handleCityListByProvinceId(value)}
										options={(address.province || []).map((item) => ({
											value: item.inT__ProvinceId,
											label: item.stR_ProvinceName,
										}))}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item className="input-normal" name="cityid" label="شهر" rules={[validateInput({ t, validate: true })]}>
									<Select
										showSearch
										optionFilterProp="label"
										options={(address.city || []).map((item) => ({
											value: item.inT_CityId,
											label: item.stR_CityName,
										}))}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item className="input-normal" name="address" label="آدرس" rules={[validateInput({ t, validate: true })]}>
									<Input.TextArea />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
			<div className="g-footer-format-page">
				<div className="holder-button">
					{/* ✅ دکمه submit واقعی */}
					<Button className="btn-normal btn-aptel" type="primary" loading={address.buttonProgress} htmlType="submit" form="frmAddress">
						مرحله بعد
					</Button>

					<Button type="default" className="btn-normal " onClick={() => setCreditCard({ ...creditCard, step: 0 })}>
						بازگشت
					</Button>
				</div>
			</div>
		</>
	);
};

export default Address;
